import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box, Button, Heading, Link } from '@primer/react';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ImageContainer = makeShortcode("ImageContainer");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ImageContainer mdxType="ImageContainer">
  <img width="868" src="https://user-images.githubusercontent.com/293280/125994797-430b8376-30f8-4971-b476-c5186f9ef6ca.png" alt="Action list examples" style={{
        "background": "none"
      }} />
    </ImageContainer>
    <h2>{`Overview`}</h2>
    <p>{`Action lists can have many applications:`}</p>
    <ul>
      <li parentName="ul">{`They’re the foundation of menus, selection panels, and other overlay components`}</li>
      <li parentName="ul">{`They can be applied to page sidebars for showing individual actions, handling local navigation, and displaying metadata`}</li>
    </ul>
    <p>{`Action lists support section dividers and headers for grouping items, and individual item dividers for added clarity.`}</p>
    <p>{`Action lists use a mobile-friendly inset style. Their sizes are adapted on touch devices, and their single-column format should render consistently in any screen size.`}</p>
    <p>{`Items in an action list are generally interactive, and respond visually to `}<inlineCode parentName="p">{`hover`}</inlineCode>{`, `}<inlineCode parentName="p">{`active`}</inlineCode>{`, and `}<inlineCode parentName="p">{`focus`}</inlineCode>{` states. Disabled and read-only items are also supported.`}</p>
    <h2>{`Anatomy`}</h2>
    <p>{`An action list can be composed of:`}</p>
    <ul>
      <li parentName="ul">{`Action list items`}</li>
      <li parentName="ul">{`Item dividers`}</li>
      <li parentName="ul">{`Section headers (subtle or filled styles)`}</li>
      <li parentName="ul">{`Section dividers (subtle or filled styles)`}</li>
    </ul>
    <img src="https://user-images.githubusercontent.com/293280/125995889-12a2de9a-7e15-4638-87dd-6796a983f733.png" alt="Action list anatomy" />
    <img src="https://user-images.githubusercontent.com/293280/125996049-e2af9cc7-c736-4adc-9800-a1d742b7929e.png" alt="Action list item anatomy" />
    <h2>{`Options`}</h2>
    <Box display="grid" gridTemplateColumns={['1fr', null, null, null, '1fr 1fr']} gridGap={5} mdxType="Box">
    <Box justifyContent="center" mdxType="Box">
        <img width="464" alt="Action list sizes" src="https://user-images.githubusercontent.com/293280/125997468-fa064d6b-ace3-4dec-920d-178478d67ba9.png" />
    </Box>
    <Box mdxType="Box">
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">Sizes</Heading>
        <Box as="p" mdxType="Box">Action list items support three different sizes: small, medium, and large. The small size is the default and most common option. Medium sizes work well for relaxed local navigation, while large sizes can support items that need more breathing room.</Box>
        <Box as="p" mdxType="Box">Sizes only grow vertically. This behavior keeps the content aligned among items, and retains horizontal space for density.</Box>
        <Box as="p" mdxType="Box">On touch devices, the large size is used at all times to ensure usability when tapping.</Box>
        <Box as="p" mdxType="Box">Be cautious when mixing different sizes in the same list to avoid inconsistency.</Box>
    </Box>
    <Box flexDirection="column" justifyContent="center" mdxType="Box">
        <Box mdxType="Box">
            <img width="464" alt="" src="https://user-images.githubusercontent.com/293280/125997571-d8b92b5e-5241-4f33-b223-825335b18f3d.png" />
            <Caption mdxType="Caption">Use leading visuals to represent system sections, features, or options.</Caption>
        </Box>
        <Box mdxType="Box">
            <img width="464" alt="" src="https://user-images.githubusercontent.com/293280/125997693-e0d9e379-19c1-4382-adbb-2a1882937373.png" />
            <Caption mdxType="Caption">Use leading visuals in important menu items.</Caption>
        </Box>
        <Box mdxType="Box">
            <img width="464" alt="" src="https://user-images.githubusercontent.com/293280/125998871-9f51e402-2ccf-4e0a-9465-65d4956c630f.png" />
            <Caption mdxType="Caption">Use leading visuals to represent content types.</Caption>
        </Box>
    </Box>
    <Box mdxType="Box">
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">Leading visual</Heading>
        <Box as="p" mdxType="Box">Leading visuals are optional and appear at the start of an item. They can be octicons, avatars, and other custom visuals that fit a small area.</Box>
        <Box as="p" mdxType="Box">When listing system sections, features, or options, use leading visuals to improve the items' scannability. In user-generated objects, they can help to indicate the item's content type and status.</Box>
        <Box as="p" mdxType="Box">Depending on the context, displaying a leading visual may not be necessary. For example, a list of branches in a select panel may not need repeated icons if the surrounding UI provides enough hints about its content type.</Box>
    </Box>
    <Box flexDirection="column" justifyContent="center" mdxType="Box">
        <Box mdxType="Box">
            <img width="464" alt="" src="https://user-images.githubusercontent.com/293280/125998961-24f90611-fe5f-4169-8943-eef68a6755a9.png" />
            <Caption mdxType="Caption">A right arrow as a trailing visual indicates there are more options to choose after selecting an item.</Caption>
        </Box>
        <Box mdxType="Box">
            <img width="464" alt="" src="https://user-images.githubusercontent.com/293280/125999062-bc489a21-cdc6-455a-8363-b7c8c7faeb3a.png" />
            <Caption mdxType="Caption">Trailing text with custom styling to indicate diff change.</Caption>
        </Box>
    </Box>
    <Box mdxType="Box">
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">Trailing visual and trailing text</Heading>
        <Box as="p" mdxType="Box">Trailing visual and trailing text can display auxiliary information. They're placed at the right of the item, and can denote status, keyboard shortcuts, or be used to set expectations about what the action does.</Box>
        <Box as="p" mdxType="Box">Note these side visuals don't have dedicated interaction targets.</Box>
        <Box as="p" mdxType="Box">
          <p>{`Use an `}<a parentName="p" {...{
              "href": "https://primer.style/octicons/arrow-right-16"
            }}><inlineCode parentName="a">{`arrow-right`}</inlineCode></a>{` octicon in menus to indicate the action will open more options, such as in a nested context. Use a `}<a parentName="p" {...{
              "href": "https://primer.style/octicons/pencil-16"
            }}><inlineCode parentName="a">{`pencil`}</inlineCode></a>{` octicon to indicate the item is going to be edited after clicking it.`}</p>
        </Box>
        <Box as="p" mdxType="Box">Custom trailing elements are supported, such as counters, labels, and other custom visuals that may help identify the item.</Box>
        <Box as="p" mdxType="Box">When using a trailing text for displaying keyboard shortcuts, always confirm the characters match with the user's operating system. For example, to indicate a bold action in a Markdown toolbar, use "Ctrl+B" on Linux and Windows, and "⌘B" on Mac. <a href="https://support.apple.com/en-us/HT201236">See reference for Mac keyboard glyphs</a>.</Box>
    </Box>
    <Box justifyContent="center" mdxType="Box">
        <img width="464" alt="Navigation list with an action button used to rerun a job, visible on hover." src="https://user-images.githubusercontent.com/18661030/193155140-ae9cca41-280b-4cc2-a0c0-1a830b12b5c9.png" />
    </Box>
    <Box mdxType="Box">
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">Trailing actions</Heading>
        <Box as="p" mdxType="Box">Trailing action buttons can be used to present a secondary interaction related to the contents of the main item, such as opening a menu or dialog. They may appear when an item is hovered, and can be keyboard focused individually.</Box>
    </Box>
    <Box justifyContent="center" mdxType="Box">
        <img width="464" alt="Multi-selection" src="https://user-images.githubusercontent.com/293280/126000062-3fc62e04-670d-4346-b65b-57c2e70ceeb0.png" />
    </Box>
    <Box mdxType="Box">
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">Item dividers</Heading>
        <Box as="p" mdxType="Box">Item dividers allow users to parse heavier amounts of information. They're placed between items and are useful in complex lists, particularly when descriptions or multi-line text is present.</Box>
        <Box as="p" mdxType="Box">When considering whether to use item dividers, make sure they truly make the presented information easier to parse, instead of only increasing visual clutter.</Box>
        <Box as="p" mdxType="Box">When using item dividers, increasing the action list item size may also help with legibility.</Box>
    </Box>
    <Box justifyContent="center" mdxType="Box">
        <img width="464" alt="Multi-selection" src="https://user-images.githubusercontent.com/293280/126000062-3fc62e04-670d-4346-b65b-57c2e70ceeb0.png" />
    </Box>
    <Box mdxType="Box">
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">Selection states</Heading>
        <Box as="p" mdxType="Box">
          <p>{`Action list items can be selected. Single selections are represented with a `}<a parentName="p" {...{
              "href": "https://primer.style/octicons/check-16"
            }}><inlineCode parentName="a">{`check`}</inlineCode></a>{` octicon, while multiple selections are represented with a checkbox component. These selection visuals are always placed at the beginning of the item.`}</p>
        </Box>
        <Box as="p" mdxType="Box">When listing selectable items alongside non-selectable items in a menu, use dividers to differentiate between the item types.</Box>
        <Box as="p" mdxType="Box">Don't mix different types of selections in the same list.</Box>
    </Box>
    <Box justifyContent="center" mdxType="Box">
        <img width="464" alt="Action list item in danger variation" src="https://user-images.githubusercontent.com/293280/125999384-b2a322db-8ec3-4a69-a414-10050544813b.png" />
    </Box>
    <Box mdxType="Box">
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">Danger items</Heading>
        <Box as="p" mdxType="Box">An action list item can have a special "danger" style, to be used in cases that require extra attention from the user.</Box>
        <Box as="p" mdxType="Box">For destructive or irremediable actions, show a confirmation dialog for extra friction. If the action is not destructive, present the user a way to undo the action instead of asking for confirmation. <a href="https://alistapart.com/article/neveruseawarning/">Never use a warning when you mean undo</a>.</Box>
        <Box as="p" mdxType="Box">Place danger items at the end of the list.</Box>
    </Box>
    </Box>
    <h2>{`Application`}</h2>
    <h3>{`In overlays`}</h3>
    <Box display="grid" gridTemplateColumns={['1fr', null, null, null, '1fr 2fr']} gridGap={4} mdxType="Box">
    <div>
        <Link href="https://primer.style/react/ActionMenu" mdxType="Link">
            <img alt="Action menu" src="https://user-images.githubusercontent.com/293280/123880964-95b3a700-d8f8-11eb-9775-cbaf165207ed.png" />
        </Link>
    </div>
    <div>
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">Action menu</Heading>
        <Box as="p" mdxType="Box">
          <p>{`Action menus are used for disambiguation, navigation, or to display secondary options. They appear when users interact with buttons, actions, or other controls.`}</p>
          <p><a parentName="p" {...{
              "href": "https://primer.style/react/ActionMenu"
            }}>{`Primer React implementation`}</a></p>
        </Box>
    </div>
    <div>
        <Link href="https://primer.style/react/ActionMenu#with-selection" mdxType="Link">
            <img alt="Action Menu with selection" src="https://user-images.githubusercontent.com/293280/123881067-cdbaea00-d8f8-11eb-98e4-e57c64489308.png" />
        </Link>
    </div>
    <div>
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">Action menu with selection</Heading>
        <Box as="p" mdxType="Box">
          <p>{`ActionMenu can be used for making a single selection among a small list of options. The list is usually predefined with system values, but in some cases it can include user-provided data when those are known not to grow into too many items.`}</p>
          <p><a parentName="p" {...{
              "href": "https://primer.style/react/ActionMenu#with-selection"
            }}>{`Primer React implementation`}</a></p>
        </Box>
    </div>
    <div>
        <Link href="https://primer.style/react/SelectPanel" mdxType="Link">
            <img alt="Select panel" src="https://user-images.githubusercontent.com/293280/123876997-4158f900-d8f1-11eb-85cb-461d9bbee0cb.png" />
        </Link>
    </div>
    <div>
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">Select panel</Heading>
        <Box as="p" mdxType="Box">
          <p>{`Select panels allow manipulating long lists of options, with filtering and other advanced interactions. They can be used for single or multi-selection.`}</p>
          <p><a parentName="p" {...{
              "href": "https://primer.style/react/SelectPanel"
            }}>{`Primer React implementation`}</a></p>
        </Box>
    </div>
    </Box>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      